import React from "react";

import { func, bool, number } from "prop-types";

import { Button, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Modal } from "@material-ui/core";
import "./changeStatusConfirmModal.css";
import CustomCloseModalButton from "../../../../../components/common/CustomCloseModalButton";
import { Field, Form, Formik } from "formik";
import { commentValidationSchema } from "./commentValidationSchema";
import { withError } from "../../../../../components/hocs";
import FormikInput from "../../../../../components/formik/Input";

const ChangeStatusConfirmModal = ({
  isOpen,
  toggle,
  handleSubmit,
  scoringStatus,
}) => {
  const ErrorInput = withError(FormikInput);

  const onSubmit = ({ comment }, { resetForm }) => {
    handleSubmit({
      comment,
      scoringStatus,
    });
    resetForm();
    toggle();
  };

  return (
    <React.Fragment>
      <Modal open={isOpen}>
        <div className="change-status-confirm-modal-body">
          <ModalHeader close={<CustomCloseModalButton toggle={toggle} />}>
            Update scoring status
          </ModalHeader>
          <Formik
            onSubmit={onSubmit}
            initialValues={{ comment: "" }}
            validationSchema={commentValidationSchema}
            validateOnChange={true}
            validateOnBlur={true}
          >
            {({ isValid }) => {
             
              return (
                <Form>
                  <ModalBody>
                    {scoringStatus === 2 && (
                      <div className="confirm-info red left">
                        Attention, once you set the status "Rejected High Risk"
                        the system will not regularly perform the regular
                        processes.
                      </div>
                    )}
                    <Field
                      type="textarea"
                      name="comment"
                      component={ErrorInput}
                    />
                  </ModalBody>
                  <ModalFooter>
                    <Button
                      className="change-status-confirm-modal-button cancel-button "
                      color="secondary"
                      onClick={toggle}
                    >
                      Cancel
                    </Button>
                    <Button
                      className="change-status-confirm-modal-button confirm-button"
                      type="submit"
                      disabled={!isValid}
                    >
                      Save
                    </Button>
                  </ModalFooter>
                </Form>
              );
            }}
          </Formik>
        </div>
      </Modal>
    </React.Fragment>
  );
};

ChangeStatusConfirmModal.propTypes = {
  isOpen: bool.isRequired,
  toggle: func.isRequired,
  handleSubmit: func.isRequired,
  scoringStatus: number.isRequired,
};

export default ChangeStatusConfirmModal;



// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/components/scoring/change-status-modal/ChangeStatusConfirmModal.jsx